export const allDecisionLogs = (state) => state.decisionLog.get("decisionLogs");
export const decisionLogPagination = (state) =>
  state.decisionLog.get("decisionLogsPagination");
export const decisionLogLoading = (state) =>
  state.decisionLog.get("decisionLogLoading");
export const decisionLogPageLoading = (state) =>
  state.decisionLog.get("pageLoading");
export const decisionLogError = (state) => state.decisionLog.get("error"); 